import React, { useEffect, useRef } from 'react';

export const Comparison = () => {
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.comparison-card').forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      card.style.transition = `all 0.6s ease ${index * 0.2}s`;
      observer.current.observe(card);
    });

    return () => observer.current?.disconnect();
  }, []);

  return (
    <section id="comparison" className="comparison">
      <div className="container">
        <div className="section-header">
          <h2>Before & After</h2>
          <p>See how LSend transforms your email code</p>
        </div>

        <div className="comparison-grid">
          <div className="comparison-card before">
            <div className="comparison-label">
              <span className="label-icon">❌</span>
              Before (Native Apex)
            </div>
            <pre><code>
              <span className="type">Messaging.SingleEmailMessage</span> email = {'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="keyword">new</span> <span className="type">Messaging.SingleEmailMessage</span>();{'\n\n'}
              email.setToAddresses(<span className="keyword">new</span> <span className="type">List</span>&lt;<span className="type">String</span>&gt;{'{'}{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="string">'user@example.com'</span>{'\n'}
              {'}'});{'\n'}
              email.setSubject(<span className="string">'Welcome!'</span>);{'\n'}
              email.setHtmlBody(<span className="string">'&lt;h1&gt;Hello&lt;/h1&gt;'</span>);{'\n'}
              email.setSenderDisplayName(<span className="string">'Acme'</span>);{'\n'}
              email.setReplyTo(<span className="string">'support@acme.com'</span>);{'\n'}
              email.setSaveAsActivity(<span className="keyword">false</span>);{'\n\n'}
              <span className="type">Messaging</span>.sendEmail({'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="keyword">new</span> <span className="type">List</span>&lt;<span className="type">Messaging.SingleEmailMessage</span>&gt;{'{'}{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;email{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;{'}'}{'\n'}
              );
            </code></pre>
          </div>

          <div className="comparison-card after">
            <div className="comparison-label">
              <span className="label-icon">✅</span>
              After (LSend)
            </div>
            <pre><code>
              <span className="keyword">LSend</span>.<span className="method">emails</span>(){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">sender</span>(<span className="string">'Acme &lt;noreply@acme.com&gt;'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">to</span>(<span className="string">'user@example.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">subject</span>(<span className="string">'Welcome!'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">html</span>(<span className="string">'&lt;h1&gt;Hello&lt;/h1&gt;'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">replyTo</span>(<span className="string">'support@acme.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">send</span>();
            </code></pre>
            <div className="comparison-stats">
              <div className="stat">
                <span className="stat-value">70%</span>
                <span className="stat-label">Less Code</span>
              </div>
              <div className="stat">
                <span className="stat-value">100%</span>
                <span className="stat-label">More Readable</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
